module.exports = __webpack_public_path__ + "e1326a6bba7a8ea6758d3074e6cf58c8.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/MT.svg
// module id = ijLx
// module chunks = 0